module.exports = __webpack_public_path__ + "media/images/top/card-online-04c84c78193e7884f6d55f3e89752283.jpg";